import { Alert, Button, Card, Checkbox, Input, Modal, Result, Select, Spin, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import { actions } from './WorkOrderSerialNumber.redux';
import Search from 'antd/es/input/Search';
import { useParams } from 'react-router-dom';

const statusList = [
	{ value: '', status: 'No Status Change' },
	{ value: 'Planned', status:'Planned' },
	{ value: 'Partial', status: 'Partial' },
	{ value: 'Hold', status:'Hold' },
	{ value: 'Waived', status:'Waived' },
	{ value: 'Complete', status:'Complete' },
];



const WorkOrderSNUpdateModal = () => {
	const dispatch            = useDispatch(),
		  params              = useParams(),
		  docNum              = params.docNum,
		  savingSerialNumbers = useSelector(state => state.workOrderSerialNum.savingSerialNumbers),
		  savingSuccess       = useSelector(state => state.workOrderSerialNum.savingSuccess),
		  newSerialNumberStatus = useSelector(state => state.workOrderSerialNum.newSerialNumberStatus),
		  currentStageID      = useSelector(state => state.workOrderSerialNum.currentStageID),
		  visible             = useSelector(state => state.workOrderSerialNum.updateModalOpen),
		  snRouteStageList    = useSelector(state => state.workOrderSerialNum.snRouteStageList),
		  opNum               = useSelector(state => state.workOrderSerialNum.opNum),
		  routeName           = useSelector(state => state.workOrderSerialNum.routeName),
		  routeDesc           = useSelector(state => state.workOrderSerialNum.routeDesc),
		  routePrintedDesc    = useSelector(state => state.workOrderSerialNum.routePrintedDesc),
		  routeRev            = useSelector(state => state.workOrderSerialNum.routeRev),
		  errors              = useSelector(state => state.workOrderSerialNum.errors),
		  [
			selectedRowKeys,
			setSelectedRowKeys
		  ]                   = useState([]),
		  [
			filteredSNListData,
			setFilteredSNListData
		  ]                   = useState([]);
		  
	let headerData = [
		{
			opNum: opNum,
			routeName: routeName,
			routeDesc: routeDesc,
			routePrintedDesc: routePrintedDesc,
			routeRev: routeRev,

		},
	];
	let headerCol = [
		{
			title: 'Op #',
			dataIndex: 'opNum',
			key: 1,
		},
		{
			title: 'Rev',
			dataIndex: 'routeRev',
			key: 1,
		},
		{
			title: 'No',
			dataIndex: 'routeName',
			key: 2,
		},
		{
			title: 'Description',
			dataIndex: 'routeDesc',
			key: 3,
		},
		{
			title: 'Printed Description',
			dataIndex: 'routePrintedDesc',
			key: 4, 
		},
	];

	useEffect(() => {
		if (visible) {
			dispatch(actions.loadWorkOrderStageSNs(docNum, currentStageID));
			setSelectedRowKeys([]);
		}
	}, [ visible ]);

	useEffect(() => {
		setSelectedRowKeys([]);
	}, [ dispatch, savingSuccess ]);

	useEffect(() => {
		setFilteredSNListData([ ...snRouteStageList ]);
	}, [ snRouteStageList ]);

	const handleSearch = (searchTerm) => {
		const newFilteredList = snRouteStageList.filter(serialNum => serialNum.U_TS_Allocated_Serial.includes(searchTerm));
		setFilteredSNListData(newFilteredList);
	};
	
	const handleClose = () => {
		dispatch(actions.setState({ updateModalOpen: false }));
		dispatch(actions.setState({ currentStageID: null }));
		dispatch(actions.setState({ snRouteStageList: [] }));
		dispatch(actions.setState({ newSerialNumberStatus: '' }));
		dispatch(actions.setState({ savingSerialNumbers: false }));
		dispatch(actions.setState({ savingSuccess: false }));
	};

	const commitRowChanges = async (value, columnName, rowId) => {
		dispatch(actions.updateSNRouteStageList(value, columnName, rowId));
	};

	const onSelectChange = (newSelectedRowKeys) => {
		setSelectedRowKeys(newSelectedRowKeys);
		
		snRouteStageList.forEach(serialNum => {
			if (_.includes(newSelectedRowKeys, serialNum.key)) {
				commitRowChanges(true, 'isSelected', serialNum.key)
			} else {
				commitRowChanges(false, 'isSelected', serialNum.key)
			}
		})
	};

	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange
	}
	

	const snRouteStageListColumns = [
		{
			title: 'Serial Number',
			dataIndex: 'U_TS_Allocated_Serial',
			width: '100px',
			filterSearch: true,
			onFilter: (value, record) => record.name.startsWith(value),
		},
		{
			title: 'Current Status',
			dataIndex: 'U_TS_WO_RS_CStatus',
			width: '150px',
		},
		{
			title: 'Notes',
			dataIndex: 'U_TS_WO_RS_Note',
			width: '300px',
			render: (text, record, index) => (
				<Input 
					value={record.U_TS_WO_RS_Note}
					onChange={(e) => {
						const value = e.target.value;
						commitRowChanges(value, 'U_TS_WO_RS_Note', index);
					}}
				/>
			)
		},
		{
			title: 'Data As Needed',
			dataIndex: 'U_TS_WO_RS_DataAsNeeded',
			render: (text, record, index) => (
				<Input 
					value={record.U_TS_WO_RS_DataAsNeeded}
					onChange={(e) => {
						const value = e.target.value;
						commitRowChanges(value, 'U_TS_WO_RS_DataAsNeeded', index);
					}}
				/>
			)
		},
	];


    return (
		<Modal
			open={visible}
			onCancel={() => handleClose()}
			maskClosable={false}
			closable={!savingSerialNumbers}
			width={1000}
			bodyStyle={{ overflowY: 'auto', maxHeight: 'calc(100vh - 250px)' }}
			title="Update Serial Number Route Stage Status"
			footer={[
				<div key="save_div" className="ts-full-width">
					{
						!savingSuccess &&
						<>
							{/* Added feature to override Rev from portal. Leaving it commented till requested. Might have to move it to Stage Table if its not on the route stage SN level
								Currently Overriding Rev is done in SAP on WOR4
								Also Uncomment isOverride component state
							*/}
							{/* <div
								style={{float: 'left'}}>
								<Checkbox className="ts_margin_left"  onChange={(e) => setIsOverride(e.target.checked)}>Override Rev</Checkbox>
								<Input 
									//value={U_TS_WO_RS_CompRev}
									className="ts_margin_left"
									style={{width: '50px'}}
									disabled={!isOverride}
									onChange={(e) => {
										const value = e.target.value.toUpperCase();
										console.log('rev value:', value.toUpperCase());
										dispatch(actions.setState({ overrideRev: value }));
									}}
								/>
							</div> */}
							<Select 
								size='large'
								placeholder="Choose New Status"
								value={newSerialNumberStatus}
								disabled={savingSerialNumbers}
								onChange={(value) => {
									dispatch(actions.setState({ newSerialNumberStatus: value }));
								}}
							>
								{
									statusList.map((status) => {
										return (
											<Select.Option
												key={'modal_'+status.value}
												value={status.value}
											> 
												{status.status}
											</Select.Option>
										);
									})
								}

							</Select>

							<Button 
								className='ts_margin_left' 
								size='large' 
								type='primary'
								disabled={savingSerialNumbers}
								onClick={() => {
									dispatch(actions.writeSerialNumberRouteStageUpdate())
								}}
							>
								Submit to SAP
							</Button>
						</>
					}
					
					<Button 
						key="sn_update_modal_cancel"
						className='ts_margin_left_wide' 
						size='large'
						type='default' 
						disabled={savingSerialNumbers}
						onClick={() => handleClose()}
					>
						Close
					</Button>
				</div>,
			]}
		>
			<Card className="ts-full-width ts_margin_top">
				{
					(savingSerialNumbers || savingSuccess) &&
						<div className="ts-area-cover">
							{
								savingSerialNumbers &&
								<Spin tip="saving" size="large">
									<p>Please wait</p>
								</Spin>
							}
							
							{
								savingSuccess &&
								<Result
									status="success"
									title="Serial Numbers and stage status updated successfully"
									subTitle="You can now close this modal"
								/>
							}
						</div>
				}
				<div className="ts_margin_bottom ts_form_container">
					<Search 
						placeholder="Search by Serial Number"
						size="medium"
						onSearch={(value) => {
							handleSearch(value)
						}}
					/>
				</div>
				<div className="ts_margin_bottom">
					<Table
						dataSource={headerData} 
						columns={headerCol}
						pagination={false}
					/>
				</div>
				{errors.map(message => (
					<Alert message={message} key={message} type="error" />))
				}
				<Table 
					dataSource={filteredSNListData} 
					columns={snRouteStageListColumns}
					rowSelection={rowSelection}
					preserveSelectedRowKeys={false}
					virtual
					pagination={false}
				/>
				
			</Card>
		</Modal>
    );
};

export default WorkOrderSNUpdateModal;
